import { Button } from 'component/Button'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { EmailInput } from 'page/ProfileScreen/Email/EmailInput'
import { store } from 'store/store'

export const EmailForm = observer(() => {
  const { email } = store.banner
  const { description, agreement } = store.options?.email ?? {}
  const placeholder = description || i18n('EmailPlaceholder')

  const onSend = useLatestCallback(async () => {
    if (email.check()) {
      void email.save()
      store.banner.close()
    }
  })

  return <Vertical gap={12}>
    <Typo size={16}>{placeholder}</Typo>
    <EmailInput it={email} />
    <Button large primary action={onSend}>
      {i18n('SendData')}
    </Button>
    <Typo size={10} secondary center pre>{agreement || i18n('SendDataAgreement')}</Typo>
  </Vertical>
})
